import { Component, OnInit, OnChanges } from '@angular/core';
import { ProfileService } from './profile.service';
import { User } from './profile.model';
import { SessionStateService } from '../../core/services/session-state.service';
import { NewUserDialogComponent } from './new-user-dialog/new-user-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';
import { DeleteUserDialogComponent } from './delete-user-dialog/delete-user-dialog.component';
import { EditProfileDialogComponent } from './edit-profile-dialog/edit-profile-dialog.component';
import { GeneralService } from '../../shared/services/general.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  menu = [];

  hasType: boolean;

  constructor() { }

  ngOnInit() {
    this.menu.push('USERS');
    this.menu.push('HOUSE');
    this.menu.push('SERVICEDETAILS');
  }

  changeTab(event) {
    this.hasType = event;
  }

  treatMenu(item: string): string {
    if ( item === 'SERVICEDETAILS' ) {
      return 'SERVICE DETAILS';
    } else {
      return item;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/profile/profile.component.ts